/* @generated from adl module ferovinum.sourcecontracts.expense */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './../app/db';

/**
 * The published `source__app_db.expense` contract.
 */
export interface ExpenseSource {
  id: ferovinum_app_db.ExpenseId;
  reference: common_strings.StringNE;
  expenseTypeCode: common_strings.StringNE;
  currency: common_strings.StringNE;
  value: common_strings.StringNE;
  expenseDate: common.LocalDate;
  organisationId: ferovinum_app_db.OrganisationId;
  feroEntity: common_strings.StringNE;
  description: common_strings.StringNE;
  notes: (common_strings.StringMD|null);
  vendor: (common_strings.StringNE|null);
  vendorReference: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseSource(
  input: {
    id: ferovinum_app_db.ExpenseId,
    reference: common_strings.StringNE,
    expenseTypeCode: common_strings.StringNE,
    currency: common_strings.StringNE,
    value: common_strings.StringNE,
    expenseDate: common.LocalDate,
    organisationId: ferovinum_app_db.OrganisationId,
    feroEntity: common_strings.StringNE,
    description: common_strings.StringNE,
    notes: (common_strings.StringMD|null),
    vendor: (common_strings.StringNE|null),
    vendorReference: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseSource {
  return {
    id: input.id,
    reference: input.reference,
    expenseTypeCode: input.expenseTypeCode,
    currency: input.currency,
    value: input.value,
    expenseDate: input.expenseDate,
    organisationId: input.organisationId,
    feroEntity: input.feroEntity,
    description: input.description,
    notes: input.notes,
    vendor: input.vendor,
    vendorReference: input.vendorReference,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseSource_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.sourcecontracts.expense","decl":{"annotations":[{"value":{"modelName":"source__app_db.expense","grain":["id"],"tags":["revenue","source"]},"key":{"moduleName":"ferovinum.sourcecontracts.common","name":"SourceContract"}},{"value":"The published `source__app_db.expense` contract.\n","key":{"moduleName":"sys.annotations","name":"Doc"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ExpenseId"}},"parameters":[]}},{"annotations":[],"serializedName":"reference","default":{"kind":"nothing"},"name":"reference","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseTypeCode","default":{"kind":"nothing"},"name":"expenseTypeCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"currency","default":{"kind":"nothing"},"name":"currency","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"value","default":{"kind":"nothing"},"name":"value","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseDate","default":{"kind":"nothing"},"name":"expenseDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"feroEntity","default":{"kind":"nothing"},"name":"feroEntity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringMD"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendor","default":{"kind":"nothing"},"name":"vendor","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"vendorReference","default":{"kind":"nothing"},"name":"vendorReference","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseSource","version":{"kind":"nothing"}}};

export const snExpenseSource: ADL.ScopedName = {moduleName:"ferovinum.sourcecontracts.expense", name:"ExpenseSource"};

export function texprExpenseSource(): ADL.ATypeExpr<ExpenseSource> {
  return {value : {typeRef : {kind: "reference", value : snExpenseSource}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.sourcecontracts.expense.ExpenseSource" : ExpenseSource_AST
};
